import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "investment-alloc-container" }

import { ref, computed, onBeforeUpdate } from "vue";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import CalculationExplanation from "../common/CalculationExplanation.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InvestmentAllocationChart',
  props: {
    title: { type: String, default: "Fund Splits" },
    data: { type: Array<any>, required: true }
},
  emits: ["showCalcs"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const DetailChart = ref(null);

onBeforeUpdate(() => {
  DetailChart.value.chart.reflow();
})

const getDetailChartData = computed(() => {
  const data = [
    {
      colorByPoint: true,
      data: props.data
    }
  ];

  return data;
});

const detailChartOptions = computed<object>(() => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      height: 280
    },
    title: {
      text: props.title,
      style: {
        color: "#5c5b5b",
        fontWeight: "600",
        fontSize: "13px"
      }
    },
    tooltip: {
      enabled: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: "pointer",
        size: "90%",
        dataLabels: {
          enabled: true,
          overflow: "justify",
          distance: 20,
          style: {
            fontSize: "0.9em",
            fontWeight: "lighter"
          },
          formatter: function() {
            return (
              this.point.name +
              ": " +
              Highcharts.numberFormat(this.y, 1, ".", ",") + "%"
            );
          }
        }
      }
    },
    series: getDetailChartData.value,
    credits: {
      enabled: false
    }
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Chart), {
      ref_key: "DetailChart",
      ref: DetailChart,
      options: detailChartOptions.value
    }, null, 8, ["options"]),
    _createVNode(CalculationExplanation, {
      onShowCalcs: _cache[0] || (_cache[0] = ($event: any) => (emit('showCalcs')))
    })
  ]))
}
}

})